export default __webpack_public_path__ + "static/partnerColorIcon19-274935ac0882a385721c7353a4a1ea37.svg";